module.exports = __webpack_public_path__ + "static/media/header_contact.03dbe029.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header_contact.jpg
// module id = 878
// module chunks = 0